import { useQuery } from '@tanstack/react-query';

import { fetchPatientInboundFaxes, fetchPatientOutboundFaxes } from '../api/fetchPatientFaxes';

const patientFaxKeys = {
  all: ['patient-faxes'] as const,
  outbound: (userId: string) => [...patientFaxKeys.all, 'outbound', userId] as const,
  inbound: (userId: string) => [...patientFaxKeys.all, 'inbound', userId] as const,
};

export function usePatientOutboundFaxesQuery(userId: string | undefined) {
  return useQuery({
    queryKey: patientFaxKeys.outbound(userId ?? ''),
    queryFn: ({ signal }) => fetchPatientOutboundFaxes(userId ?? '', signal),
    enabled: Boolean(userId),
    meta: {
      toast: {
        title: 'Could not load outbound faxes',
        description: 'Outbound faxes could not be fetched.',
      },
    },
  });
}

export function usePatientInboundFaxesQuery(userId: string | undefined) {
  return useQuery({
    queryKey: patientFaxKeys.inbound(userId ?? ''),
    queryFn: ({ signal }) => fetchPatientInboundFaxes(userId ?? '', signal),
    enabled: Boolean(userId),
    meta: {
      toast: {
        title: 'Could not load inbound faxes',
        description: 'Inbound faxes could not be fetched.',
      },
    },
  });
}
